import Lottie from "lottie-react";
import AudioPlayer from "../../../../components/AudioPlayer/AudioPlayer";
import WebShadowButton from "../../../WebStoryScreen/Components/WebShadowButton";
import closeIcon from "../../../../appAssets/closeIcon.png";
import {
  BreatheExercise,
  MindfulMoment,
} from "../../../../hooks/useRetrieveBreatheExercise";
import {
  meditatingYeti,
  MindfulMoment_icon,
} from "../../../../appAssets/jsons";
import "./MindfulMomentContent.scss";

function formatTime(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s < 10 ? `0${s}` : s}`;
}

interface MindfulMomentContentProps {
  mindfulMoment: MindfulMoment;
  exercise: BreatheExercise;
  phase: "prompt" | "listening";
  timer: number;
  isAudioPlaying?: boolean;
  onStart: () => void;
  handleClose: () => void;
}

function MindfulMomentContent({
  mindfulMoment,
  exercise,
  phase,
  timer,
  isAudioPlaying = true,
  onStart,
  handleClose,
}: MindfulMomentContentProps) {
  // ── Listening phase: full-screen layout mirroring RainbowContent ──────────
  if (phase === "listening") {
    return (
      <div className="mindful-moment__listening">
        <div className="mindful-moment__listening-center">
          <Lottie
            animationData={meditatingYeti}
            loop
            autoplay
            className="mindful-moment__listening-yeti"
          />

          {isAudioPlaying && mindfulMoment.bgMusicUrl && (
            <AudioPlayer
              uri={mindfulMoment.bgMusicUrl}
              autoPlay
              loop
              variant="compact"
            />
          )}
        </div>
        {timer > 0 && (
          <span className="mindful-moment__listening-timer">
            {formatTime(timer)}
          </span>
        )}
      </div>
    );
  }

  // ── Prompt phase: grey backdrop + white card ──────────────────────────────
  // Play exercises[2] audio/bgMusic while the card is visible (same as RainbowContent does for regular flow)
  return (
    <div className="mindful-moment__backdrop">
      {isAudioPlaying && mindfulMoment.audioUrl && (
        <AudioPlayer uri={mindfulMoment.audioUrl} autoPlay variant="compact" />
      )}
      <div className="mindful-moment__card">
        <div className="mindful-moment__badge-row">
          <div />
          <div className="mindful-moment__badge">
            <Lottie
              animationData={MindfulMoment_icon}
              loop
              autoplay
              className="mindful-moment__badge-emoji"
            />
            <span className="mindful-moment__badge-text">MINDFUL MOMENT</span>
          </div>
          <button
            type="button"
            className="breathe__close"
            onClick={handleClose}
            aria-label="Close"
          >
            <img src={closeIcon} alt="Close" className="breathe__close-icon" />
          </button>
        </div>

        <p className="mindful-moment__title">{mindfulMoment.title}</p>

        <WebShadowButton
          title="Let's start!"
          onPress={onStart}
          className="mindful-moment__start-btn"
        />
      </div>
    </div>
  );
}

export default MindfulMomentContent;
